import * as React from "react";

function SvgInfoIcon(props) {
    let fill='black';
    if(props?.iconVariant){
        if(props?.iconVariant==='light'){
            fill = 'white';
        } else if(props?.iconVariant==='dark'){
            fill = 'black';
        }
    }
  return (

    
    // <svg  style={{verticalAlign: "center", pointerEvents:"none", fill:fill, filter: 'contrast(5) brightness(5)'}} version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg"  x="0px" y="0px" width="12px" height="12px"

    //     viewBox="0 0 550 550"  >
    // <g>
    //     <g>
    //         <path d="M256,0C114.497,0,0,114.507,0,256c0,141.503,114.507,256,256,256c141.503,0,256-114.507,256-256
    //             C512,114.497,397.492,0,256,0z M256,472c-119.393,0-216-96.615-216-216c0-119.393,96.615-216,216-216
    //             c119.393,0,216,96.615,216,216C472,375.393,375.384,472,256,472z"/>
    //     </g>
    // </g>
    // <g>
    //     <g>
    //         <path d="M256,214.33c-11.046,0-20,8.954-20,20v128.793c0,11.046,8.954,20,20,20s20-8.955,20-20.001V234.33
    //             C276,223.284,267.046,214.33,256,214.33z"/>
    //     </g>
    // </g>
    // <g>
    //     <g>
    //         <circle cx="256" cy="162.84" r="26"/>
    //     </g>
    // </g>

    // </svg>
    <svg style={{verticalAlign: "center", pointerEvents:"none", fill:fill, filter: 'contrast(5) brightness(5)'}} version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg"  x="0px" y="0px" width="12px" height="12px" viewBox="0 0 16 16">
        <path fill-rule="evenodd" clip-rule="evenodd" d="M8 5.90002C8.55228 5.90002 9 5.45231 9 4.90002C9 4.34774 8.55228 3.90002 8 3.90002C7.44772 3.90002 7 4.34774 7 4.90002C7 5.45231 7.44772 5.90002 8 5.90002Z" fill="#606060"/>
        <path fill-rule="evenodd" clip-rule="evenodd" d="M8.4998 12.1H7.4998C7.3998 12.1 7.2998 12 7.2998 11.9V7.50005C7.2998 7.40005 7.3998 7.30005 7.4998 7.30005H8.4998C8.5998 7.30005 8.6998 7.40005 8.6998 7.50005V11.9C8.7998 12 8.5998 12.1 8.4998 12.1Z" fill="#606060"/>
        <path fill-rule="evenodd" clip-rule="evenodd" d="M7.9998 15.2C3.9998 15.2 0.799805 12 0.799805 8.00005C0.799805 4.00005 3.9998 0.800049 7.9998 0.800049C11.9998 0.800049 15.1998 4.00005 15.1998 8.00005C15.1998 12 11.9998 15.2 7.9998 15.2ZM7.9998 2.20005C4.7998 2.20005 2.1998 4.80005 2.1998 8.00005C2.1998 11.2 4.7998 13.8 7.9998 13.8C11.1998 13.8 13.7998 11.2 13.7998 8.00005C13.7998 4.80005 11.1998 2.20005 7.9998 2.20005Z" fill="#606060"/>
    </svg>
  );
}

export default SvgInfoIcon;